import { useState } from "react";
import { newsCards, categories } from "@/mocks/data";

export default function Feed() {
  const [active, setActive] = useState("全部");
  const tabs = ["全部", ...categories.map((c) => c.name)];
  const list = active === "全部" ? newsCards : newsCards.filter((n) => n.tag === active);

  return (
    <section id="feed" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="mb-3 text-sm font-medium text-primary-600">
              <i className="ri-focus-3-line mr-2"></i>
              最新瓜报
            </div>
            <h2 className="font-heading text-2xl text-foreground-950 md:text-4xl">
              今日上新,一手蹲到
            </h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              编辑每日精筛的圈内新瓜,配图、概述与热度一览,睡前必看与通勤速览都在这里取菜。
            </p>
          </div>
          <div className="flex flex-wrap gap-1 rounded-full bg-background-100 p-1 ring-1 ring-background-200">
            {tabs.map((t) => (
              <button
                key={t}
                onClick={() => setActive(t)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  active === t
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:bg-background-200"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((n) => (
            <article
              key={n.id}
              className="group flex flex-col overflow-hidden rounded-2xl bg-background-100 ring-1 ring-background-200 transition-transform hover:-translate-y-1"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={n.image}
                  alt={n.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-600">
                  {n.tag}
                </span>
                <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-foreground-950/40 px-2.5 py-1 text-xs text-background-50">
                  <i className="ri-fire-line text-accent-400"></i>
                  {n.hot}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="text-sm font-semibold leading-snug text-foreground-900 md:text-base">
                  {n.title}
                </h3>
                <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-500">
                  {n.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {n.time}
                  </span>
                  <a
                    href="#signup"
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector("#signup")?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="flex items-center gap-1 whitespace-nowrap font-medium text-primary-600 hover:text-primary-700"
                  >
                    蹲全文
                    <i className="ri-arrow-right-s-line text-base"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}